import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { CreateClientAppState, MainAppState } from "../appState/models";

export const appStateSelector = createDraftSafeSelector(
  (state: MainAppState) => state,
  (state: MainAppState) => state.createClient.client,
);

export const createClientSelector = createDraftSafeSelector(
  appStateSelector,
  (state: CreateClientAppState) => state.createClientData,
);

export const editClientSelector = createDraftSafeSelector(
  appStateSelector,
  (state: CreateClientAppState) => state.editClientData,
);
